"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Themes = exports.DEFAULT_THEME = exports.DEFAULT_FONT_SIZE = exports.DEFAULT_COLOR = exports.ARR_SPACING_TYPES = exports.ARR_FONT_WEIGHT = exports.ARR_FONT_SIZE = exports.ARR_COLORS = exports.ARR_BORDER_RADIUS = exports.ARR_BACKGROUND_COLORS = exports.AIRASIA_PREMIUM = void 0;

var ThemesObj = _interopRequireWildcard(require("./themes"));

var _theme = _interopRequireDefault(require("./lib/AirasiaClassic/theme"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var DEFAULT_THEME = 'AIRASIA_CLASSIC';
exports.DEFAULT_THEME = DEFAULT_THEME;
var AIRASIA_PREMIUM = 'AIRASIA_PREMIUM';
exports.AIRASIA_PREMIUM = AIRASIA_PREMIUM;
var DEFAULT_COLOR = 'neutral';
exports.DEFAULT_COLOR = DEFAULT_COLOR;
var DEFAULT_FONT_SIZE = 'normal';
exports.DEFAULT_FONT_SIZE = DEFAULT_FONT_SIZE;
var Themes = Object.keys(ThemesObj);
exports.Themes = Themes;
var ARR_SPACING_TYPES = Object.keys(_theme.default.space);
exports.ARR_SPACING_TYPES = ARR_SPACING_TYPES;
var ARR_COLORS = Object.keys(_theme.default.colors);
exports.ARR_COLORS = ARR_COLORS;
var ARR_BACKGROUND_COLORS = Object.keys(_theme.default.backgroundColor);
exports.ARR_BACKGROUND_COLORS = ARR_BACKGROUND_COLORS;
var ARR_FONT_SIZE = Object.keys(_theme.default.fontSize);
exports.ARR_FONT_SIZE = ARR_FONT_SIZE;
var ARR_BORDER_RADIUS = Object.keys(_theme.default.borderRadius);
exports.ARR_BORDER_RADIUS = ARR_BORDER_RADIUS;
var ARR_FONT_WEIGHT = Object.keys(_theme.default.fontWeight);
exports.ARR_FONT_WEIGHT = ARR_FONT_WEIGHT;